import { render } from "./ConfidentialitatePage.vue?vue&type=template&id=2c544414&scoped=true"
import script from "./ConfidentialitatePage.vue?vue&type=script&lang=js"
export * from "./ConfidentialitatePage.vue?vue&type=script&lang=js"

import "./ConfidentialitatePage.vue?vue&type=style&index=0&id=2c544414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c544414"]])

export default __exports__